import { BrowserCodeReader } from '@zxing/browser'

const ensureCameraSupport = () => {
  if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) return

  const error = new Error('Camera access is not supported by this browser.')
  error.name = 'NotSupportedError'
  throw error
}

export const listCameras = async () => {
  ensureCameraSupport()

  const devices = await BrowserCodeReader.listVideoInputDevices()
  return devices.map(device => ({
    id: device.deviceId,
    label: device.label
  }))
}

export const getCameras = async () => {
  ensureCameraSupport()

  const stream = await navigator.mediaDevices.getUserMedia({
    video: true,
    audio: false
  })

  stream.getTracks().forEach(track => track.stop())

  return listCameras()
}

export const pickDefaultCameraId = (cameras) => {
  const backCamera = cameras.find(camera =>
    /back|rear|environment|trasera/i.test(camera.label || '')
  )

  return backCamera ? backCamera.id : cameras[0]?.id || null
}
